{
  "general": [
    {
      "name": "DDE",
      "value": "eCOS.DDE"
    },
    {
      "name": "Assortiment",
      "value": "eCOS.Assortiment"
    },
    {
      "name": "Assort Inno Definitive",
      "value": "eCOS.InnoDefinitive"
    },
    {
      "name": "SFA",
      "value": "eCOS.SFA"
    },
    {
      "name": "Spécialisation",
      "value": "eCOS.Specialization"
    }
  ],
  "in": [
    {
      "name": "EDI.Expedition",
      "value": "eCOS.EDI.Expedition"
    },
    {
      "name": "EDI.Transport",
      "value": "eCOS.EDI.Transport"
    },
    {
      "name": "EDI.Movement",
      "value": "eCOS.EDI.Movement"
    },
    {
      "name": "EDI.Inventory",
      "value": "eCOS.EDI.Inventory"
    },
    {
      "name": "EDI.Merch",
      "value": "eCOS.EDI.In-Merch"
    },
    {
      "name": "EDI.Merch statement",
      "value": "eCOS.EDI.In-MerchStatement"
    },
    {
      "name": "EDI.Rent",
      "value": "eCOS.EDI.In-Rent"
    },
    {
      "name": "EDI.Rent service",
      "value": "COS.EDI.In-RentService"
    },
    {
      "name": "EDI.Rent statement",
      "value": "eCOS.EDI.In-RentStatement"
    },
    {
      "name": "EDI.Rent transport",
      "value": "eCOS.EDI.In-RentTransport"
    },
    {
      "name": "EDI.Service",
      "value": "eCOS.EDI.In-Service"
    },
    {
      "name": "EDI.Service statement",
      "value": "eCOS.EDI.In-ServiceStatement"
    },
    {
      "name": "EDI.Expedition Assort (PF)",
      "value": "eCOS.EDI.In-ExpeditionAssort"
    },
    {
      "name": "EDI.Transport Assort (PF)",
      "value": "eCOS.EDI.In-TransportAssort"
    },
    {
      "name": "EDI.Transport RSW 2",
      "value": "eCOS.EDI.TransportRSW2"
    },
    {
      "name": "EDI.Expedition RSW 2",
      "value": "eCOS.EDI.ExpeditionRSW2"
    },
    {
      "name": "EDI.Inventory RSW 2",
      "value": "eCOS.EDI.InventoryRSW2"
    },
    {
      "name": "EDI.Order RSW return 2",
      "value": "eCOS.EDI.In-OrderRSWReturn2"
    },
    {
      "name": "EDI.OrderExternal",
      "value": "eCOS.EDI.In-OrderExternal"
    },
    {
      "name": "EDI.PickingExternal",
      "value": "eCOS.EDI.In-PickingExternal"
    },
    {
      "name": "EDI.BillingExternal",
      "value": "eCOS.EDI.In-BillingExternal"
    }
  ],
  "out": [
    {
      "name": "EDI.Product",
      "value": "eCOS.EDI.Out-Product"
    },
    {
      "name": "Groupage",
      "value": "eCOS.Groupage"
    },
    {
      "name": "EDI.Order",
      "value": "eCOS.EDI.Out-Order"
    },
    {
      "name": "EDI.Merch",
      "value": "eCOS.EDI.Out-Merch"
    },
    {
      "name": "EDI.Merch statement",
      "value": "eCOS.EDI.Out-MerchStatement"
    },
    {
      "name": "EDI.Rent",
      "value": "eCOS.EDI.Out-Rent"
    },
    {
      "name": "EDI.Rent service",
      "value": "eCOS.EDI.Out-RentService"
    },
    {
      "name": "EDI.Service",
      "value": "eCOS.EDI.Out-Service"
    },
    {
      "name": "EDI.Service statement",
      "value": "eCOS.EDI.Out-ServiceStatement"
    },
    {
      "name": "EDI.Order Assort (PF)",
      "value": "eCOS.EDI.Out-OrderAssort"
    },
    {
      "name": "EDI.Order RSW 2",
      "value": "eCOS.EDI.Out-OrderRSW2"
    },
    {
      "name": "EDI.Order RSW destruction 2",
      "value": "eCOS.EDI.Out-OrderRSWDestruction2"
    },
    {
      "name": "EDI.Order RSW return central 2",
      "value": "eCOS.EDI.Out-OrderRSWReturnCentral2"
    }
  ]
}